import { Box, Typography } from "@mui/material";
import { labelStyles } from "./styles";

export const PopularLabel = () => {
  return (
    <Box sx={labelStyles}>
      <Typography
        variant="body2"
        color="white"
        fontSize={{ xs: 14, md: 12 }}
        fontWeight={{ xs: 500, md: 600 }}
        sx={{ whiteSpace: "nowrap" }}
      >
        Most popular
      </Typography>
    </Box>
  );
};
